import { ClassicPreset, GetSchemes } from 'rete';
import { AngularArea2D } from 'rete-angular-plugin/20';
import { ProductType } from 'src/app/services/product-service/product-service.service';
import { DialogName } from 'src/app/shared/workflow-dialogs/dialog-dictionary';

export abstract class Node extends ClassicPreset.Node {
  abstract width: number;
  abstract height: number;

  constructor(label: string) {
    super(label);
  }
}
export class Connection<N extends Node> extends ClassicPreset.Connection<N, N> { }

export type Schemes = GetSchemes<
  Node,
  Connection<Node>
>;
export type AreaExtra = AngularArea2D<Schemes>;

export const roles = [
  'any',
  'admin',
  'attorney',
  'user',
] as const;
export type Role = typeof roles[number];

export type WorkflowExpectedTransition = {
  label: string;
  at: string;
};

export type WorkflowState = {
  id: string;
  class_name: string;
  stage: 'START_PENDING'
  | 'ONGOING'
  | 'CLOSE_PENDING'
  | 'CLOSED';
  label: string;
  color: {
    text_color: string;
    background_color: string;
  };
  is_entry_point: boolean;
  is_refundable: boolean;
  is_start: boolean;
  expected_transition: WorkflowExpectedTransition | null;
};

export type WorkflowNotification = {
  id: string;
  label: string;
};

export type WorkflowTransition = {
  id: string;
  class_name: string;
  is_begin: boolean;
  is_start: boolean;
  is_info_notification: boolean;
  roles: null | Role[];
  from_process_states: null | string[];
  to_process_state: null | string;
  notifications: WorkflowNotification[];
  delete_pending_notifications: boolean;
  mark_deadlines_complete: boolean;
  dialog: null | DialogName;
  label: string;
  log_label: string;
  group: string;
  hide_from_events: boolean;
  hide_from_actions: boolean;
};

export type WorkflowProcess = {
  id: string;
  label: string;
  products: ProductType[];
  states: WorkflowState[];
  transitions: WorkflowTransition[];
};